export default __webpack_public_path__ + "static/media/typeShip.72f79645.72f79645.svg";